import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductDetailModalModel } from './models/ProductDetailModalModel';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { bootstrapBox2Fill } from '@ng-icons/bootstrap-icons';

@Component({
  selector: 'app-product-detail-modal',
  standalone: true,
  imports: [NgIconComponent],
  templateUrl: './product-detail-modal.component.html',
  styleUrl: './product-detail-modal.component.scss',
  viewProviders: [
    provideIcons({
      bootstrapBox2Fill
    })
  ]
})
export class ProductDetailModalComponent {
  @Input()
  orderNumber!: string;

  @Input()
  productDetails!: ProductDetailModalModel;

  constructor(public activeModal: NgbActiveModal) { }
}
